import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button } from 'antd-mobile-v5'
import { Modal, Toast, WingBlank } from 'antd-mobile'
import { getSubmitOssFormat, showAlert, showModal } from '../../components/common/utils'
import { efriApproved } from '../../services/api'
import { usePayEfri } from '../../services/hooks'
import PaymentBtn from '../../components/FormTools/PaymentBtn'
import AgreementPopup from '../../components/FormTools/AgreementPopup'
import StepStatus from '../../components/FormTools/StepStatus'
import { isTaiwanUser } from '../../utils/user'

import styles from '../DiveMasterForm/DiveMasterForm.module.css'

const ApplicationStatusContent = ({ form, detail, getSubmitData, signature, setVisible }) => {
  const { replace } = useHistory()
  const { formatMessage } = useIntl()
  const { runAsync: toPayEfri } = usePayEfri()

  const { profile } = useSelector((state) => ({
    profile: state.data.profile,
  }))

  const { status, note, payerType, code, paymentMethod } = detail
  const editableStatus = status === 'ADMIN_NOT_APPROVED' || status === 'WAIT_CONFIRM'

  const approvedAction = async (approve) => {
    await form.validateFields()
    if (!signature) {
      showModal(
        formatMessage({ id: 'common-errorTitle' }),
        formatMessage({ id: 'dm-form-signature-confirm' }),
        () => {},
        () => {},
        formatMessage({ id: 'common-comfirmBtn' }),
        formatMessage({ id: 'common-cancel' })
      )
      return
    }
    if (approve) {
      if (!payerType) {
        Modal.alert('', formatMessage({ id: 'owsi-pay-tips' }), [
          { text: formatMessage({ id: 'common-applicant-pay' }), onPress: () => submitApprovedFn('EFRI') },
          { text: formatMessage({ id: 'efri-efrt-pay' }), onPress: () => submitApprovedFn('EFRT') },
          { text: formatMessage({ id: 'common-cancel' }), onPress: () => console.log('cancel') },
        ])
      } else {
        submitApprovedFn()
      }
    } else {
      Modal.prompt(formatMessage({ id: 'dm-refuse-reason' }), formatMessage({ id: 'dm-refuse-tips' }), [
        { text: formatMessage({ id: 'common-cancel' }) },
        {
          text: formatMessage({ id: 'common-comfirmBtn' }),
          onPress: async (value) => {
            if (!value) {
              showModal(
                '',
                formatMessage({ id: 'dm-refuse-error' }),
                () => {},
                () => {},
                formatMessage({ id: 'common-comfirmBtn' }),
                formatMessage({ id: 'common-cancel' })
              )
              return
            }
            const approvedData = {
              approve,
              code: detail.code,
              handwrittenSignatureUrl: getSubmitOssFormat(signature),
              note: value,
              // courseDate
            }
            try {
              Toast.loading()
              const response = await efriApproved(approvedData)
              if (response.error) {
                showAlert(response.error.clientMsg, formatMessage({ id: 'common-close' }))
              } else {
                replace('/efrt_list')
              }
            } catch (e) {
              showAlert(formatMessage({ id: 'common-errorStatus' }), formatMessage({ id: 'common-close' }))
            } finally {
              Toast.hide()
            }
          },
        },
      ])
    }
  }

  const submitApprovedFn = (payerType) => {
    showModal(
      '',
      formatMessage({ id: 'dm-form-instructor-accept-confirm' }),
      async () => {
        let approvedData = {
          approve: true,
          code: detail.code,
          handwrittenSignatureUrl: getSubmitOssFormat(signature),
        }
        if (editableStatus) {
          const formData = getSubmitData()
          approvedData = {
            ...formData,
            ...approvedData,
          }
        }
        if (payerType) approvedData.payerType = payerType
        try {
          Toast.loading()
          const response = await efriApproved(approvedData)
          if (response.error) {
            showAlert(response.error.clientMsg, formatMessage({ id: 'common-close' }))
          } else {
            if (payerType === 'EFRT') {
              if (profile.teachingLocation === 'TW' || isTaiwanUser()) {
                setVisible(true)
              } else {
                replace('/efrt_list')
              }
            } else replace('/efrt_list')
          }
        } catch (e) {
          showAlert(formatMessage({ id: 'common-errorStatus' }), formatMessage({ id: 'common-close' }))
        } finally {
          Toast.hide()
        }
      },
      () => {},
      formatMessage({ id: 'common-comfirmBtn' }),
      formatMessage({ id: 'common-cancel' })
    )
  }

  switch (status) {
    case 'WAIT_CONFIRM':
      return (
        <div className={styles.btns}>
          <Button inline color="primary" className={styles.btn} onClick={() => approvedAction(true)}>
            <FormattedMessage id="dm-form-agree" />
          </Button>
          <Button inline color="warning" className={styles.btn} onClick={() => approvedAction(false)}>
            <FormattedMessage id="dm-form-reject" />
          </Button>
        </div>
      )
    case 'INSTRUCTOR_APPROVED':
      if (paymentMethod) {
        return <StepStatus desc={formatMessage({ id: 'app-wait-cs-review' })} />
      }
      if (payerType === 'EFRT') {
        return (
          <WingBlank>
            <PaymentBtn code={code} paymentFn={toPayEfri} payApplicationType={'MEMBER_APPLICATION_EFRI'} />
          </WingBlank>
        )
      } else if (payerType === 'EFRI') {
        return <StepStatus desc={formatMessage({ id: 'dm-form-wait-pay-student' })} />
      } else {
        return null
      }
    case 'INSTRUCTOR_NOT_APPROVED':
      return <StepStatus desc={formatMessage({ id: 'app-status-instructor-not-approved' })} />
    case 'ADMIN_NOT_APPROVED':
      return (
        <>
          <div className={styles.btns}>
            <Button inline color="primary" className={styles.btn} onClick={() => approvedAction(true)}>
              <FormattedMessage id="dm-form-agree" />
            </Button>
            <Button inline color="warning" className={styles.btn} onClick={() => approvedAction(false)}>
              <FormattedMessage id="dm-form-reject" />
            </Button>
          </div>
          <StepStatus desc={formatMessage({ id: 'app-cs-not-approved' })} note={note} />
        </>
      )
    case 'ADMIN_APPROVED':
      return <StepStatus desc={formatMessage({ id: 'app-wait-cert' })} />
    case 'SUCCESS':
      return <StepStatus desc={formatMessage({ id: 'app-success' })} />
    case 'CLOSE':
      return <StepStatus desc={formatMessage({ id: 'app-close' })} />
    default:
      return null
  }
}

const ApplicationStatus = ({ form, detail, getSubmitData, signature }) => {
  const [visible, setVisible] = useState(false)
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { runAsync: toPayEfri } = usePayEfri()
  const { profile } = useSelector((state) => ({
    profile: state.data.profile,
  }))

  const toPay = async (code) => {
    const result = await toPayEfri(code)
    if (result.error) {
      showAlert(result.error.clientMsg, formatMessage({ id: 'common-close' }))
      return
    }
    if (result.url) {
      if (profile.teachingLocation === 'TW')
        return push('/invoice_form', {
          code,
          nextUrl: result.url,
          type: 'MEMBER_APPLICATION_EFRI',
        })
      window.location.replace(result.url)
    }
  }

  return (
    <>
      <ApplicationStatusContent
        signature={signature}
        detail={detail}
        form={form}
        getSubmitData={getSubmitData}
        toPay={toPay}
        setVisible={setVisible}
      />
      <AgreementPopup visible={visible} setVisible={setVisible} toPay={() => toPay(detail.code)} />
    </>
  )
}

export default ApplicationStatus
